import { render, staticRenderFns } from "./CharacterDetail.vue?vue&type=template&id=79f70ba6&scoped=true"
import script from "./CharacterDetail.vue?vue&type=script&lang=ts"
export * from "./CharacterDetail.vue?vue&type=script&lang=ts"
import style0 from "./CharacterDetail.vue?vue&type=style&index=0&id=79f70ba6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f70ba6",
  null
  
)

export default component.exports